/**
 * Copyright (c) 2025 Bytedance Ltd. and/or its affiliates
 * SPDX-License-Identifier: MIT
 */

import styled from 'styled-components';

export const UIDragNodeContainer = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 100px;
  background-color: white;
  border: 1px dashed #b8bcc1;
`;
